// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TAB_BLOGS_ALL = "V\u0161echny";
export const TAB_BLOGS_POPULAR = "Popul\u00e1rn\u00ed";
export const TAB_BLOGS_SUBSCRIBED = "Odeb\u00edr\u00e1m";
